import React from 'react';
import Button from '../../../core/form/Button';
import ColumnSeparator from '../../../core/layout/ColumnSeparator';
import PropTypes from 'prop-types';

const DraftItemListBatchActions = (props) => (
  <>
    <Button
      icon="cloud-upload"
      label="Publish selected drafts"
      onClick={props.onPublishSelectedDrafts}
      disabled={props.submitting || !props.enablePublishSelectedItems}
    />
    {props.enablePublishEntireUnit && (
      <>
        <ColumnSeparator size="xs" />
        <Button
          icon="cloud-upload"
          label="Publish entire unit"
          onClick={props.onPublishEntireUnit}
          disabled={props.submitting}
        />
      </>
    )}
    {props.enablePublishEntireMastery && (
      <>
        <ColumnSeparator size="xs" />
        <Button
          icon="cloud-upload"
          label="Publish entire mastery test"
          onClick={props.onPublishEntireMasteryTest}
          disabled={props.submitting}
        />
      </>
    )}
  </>
);

DraftItemListBatchActions.propTypes = {
  onPublishSelectedDrafts: PropTypes.func.isRequired,
  onPublishEntireUnit: PropTypes.func.isRequired,
  onPublishEntireMasteryTest: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  enablePublishSelectedItems: PropTypes.bool,
  enablePublishEntireUnit: PropTypes.bool,
  enablePublishEntireMastery: PropTypes.bool,
};

DraftItemListBatchActions.defaultProps = {
  submitting: false,
  enablePublishSelectedItems: false,
  enablePublishEntireUnit: false,
  enablePublishEntireMastery: false,
};

export default DraftItemListBatchActions;
